/**
 * Block explorer transaction URL builders by chain ID.
 */
export const TX_EXPLORER_URLS: Record<number, (hash: string) => string> = {
  1: (h) => `https://etherscan.io/tx/${h}`,
  56: (h) => `https://bscscan.com/tx/${h}`,
  137: (h) => `https://polygonscan.com/tx/${h}`,
  8453: (h) => `https://basescan.org/tx/${h}`,
  42161: (h) => `https://arbiscan.io/tx/${h}`,
  10: (h) => `https://optimistic.etherscan.io/tx/${h}`,
  43114: (h) => `https://snowtrace.io/tx/${h}`,
  11155111: (h) => `https://sepolia.etherscan.io/tx/${h}`,
};

/**
 * Solana explorer URL builder.
 */
export const getSolanaExplorerUrl = (hash: string): string => {
  return `https://solscan.io/tx/${hash}`;
};

/**
 * Get explorer URL for a transaction hash on a given chain.
 * Falls back to Etherscan if chain is unknown.
 */
export const getExplorerUrl = (chainId: number, hash: string): string => {
  const builder = TX_EXPLORER_URLS[chainId];
  if (builder) {
    return builder(hash);
  }
  // Fallback to Etherscan
  return `https://etherscan.io/tx/${hash}`;
};

/**
 * Human-readable chain names by chain ID.
 */
export const CHAIN_NAMES: Record<number, string> = {
  1: "Ethereum",
  56: "BSC",
  137: "Polygon",
  8453: "Base",
  42161: "Arbitrum",
  10: "Optimism",
  43114: "Avalanche",
  11155111: "Sepolia",
};

/**
 * Get chain name by ID, with fallback.
 */
export const getChainName = (chainId: number): string => {
  return CHAIN_NAMES[chainId] || `Chain ${chainId}`;
};
